import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveCostProfilesRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveCostProfilesRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveCostProfilesRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getCostProfiles() {
      return getState().costProfiles;
    },
  };
}

export { createSelector };
